export const hiddenColumns = ["referral", "email", "od_id", "utm_campaign", "utm_source", "utm_medium"];
